import { Habit } from "@/context/SupabaseHabitContext";
import { MoodEntry } from "@/context/MoodTrackerContext";

export function exportHabitsToCSV(habits: Habit[], moodEntries: MoodEntry[] = []): void {
  console.log('Exporting habits:', habits.length, 'mood entries:', moodEntries.length);
  console.log('Mood entries:', moodEntries);
  
  // Create CSV content with both habits and mood data
  const headers = ["Type", "Name", "Created At", "Status", "Completed Dates", "Mood Data"];
  
  // Add habit rows
  const habitRows = habits.map(habit => [
    "Habit",
    habit.name,
    new Date(habit.createdAt).toLocaleDateString(),
    habit.active === false ? "Paused" : "Active",
    habit.completedDates.join(", "),
    "" // Empty mood data for habits
  ]);

  // Add mood tracker row if there are mood entries
  const moodRows = moodEntries.length > 0 ? [[
    "Mood",
    "Mood Tracker",
    "", // No created date for mood tracker
    "Active",
    "", // No completed dates for mood tracker
    moodEntries.map(entry => `${entry.date}:${entry.mood}`).join(", ")
  ]] : [];

  console.log('Habit rows:', habitRows.length);
  console.log('Mood rows:', moodRows.length);
  if (moodRows.length > 0) {
    console.log('Mood row data:', moodRows[0]);
  }

  const csvContent = [
    headers.join(","),
    ...habitRows.map(row => row.map(cell => `"${cell}"`).join(",")),
    ...moodRows.map(row => row.map(cell => `"${cell}"`).join(","))
  ].join("\n");

  console.log('Final CSV content preview:', csvContent.substring(0, 500) + '...');

  // Create and trigger download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  
  link.setAttribute("href", url);
  link.setAttribute("download", `habitualy-export-${new Date().toISOString().split("T")[0]}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
} 